import { CalendarDateFormatter, DateFormatterParams } from 'angular-calendar';
import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';

@Injectable()
export class CustomDateFormatter extends CalendarDateFormatter {

  public weekViewHour({ date, locale }: DateFormatterParams): string {
    return new DatePipe(locale).transform(date, 'HH:mm', locale); // using 24-hour format
  }
}

